import { html, View } from 'rune-ts';
import klass from './Toast.module.scss';
import { cx, resolveElement } from '../util';

type ToastPosition =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right'
  | 'center';

interface _ToastOption {
  /** 토스트에 표시할 텍스트 메시지 */
  text: string;

  /** 토스트가 표시되는 시간 (밀리초 단위) */
  time: number;

  /** 화면에서 토스트의 위치 */
  position: ToastPosition;

  /** 지정된 위치에서의 오프셋 (x 및 y 좌표) */
  offset: { x: number | string; y: number | string };

  /** 토스트가 추가될 부모 요소 또는 선택자 */
  parent?: HTMLElement | string;

  /** 토스트 요소에 적용할 추가 CSS 클래스 */
  class: string;

  /** 토스트 테마 */
  theme: 'default' | 'error';

  /** 하나의 토스트만 표시할지 여부 */
  single: boolean;
}
export type ToastOption = Partial<_ToastOption>;

class Toast extends View<_ToastOption> {
  override template() {
    const { x = 0, y = 0 } = this.data.offset;
    return html` <div
      class="${cx(klass.toast, klass[this.data.position], this.data.class)}"
      style="${`transform: translate(${typeof x === 'number' ? `${x}px` : x}, ${typeof y === 'number' ? `${y}px` : y})`}"
      data-theme="${this.data.theme}"
    >
      ${this.data.text}
    </div>`;
  }
}

const isBodyElement = (element: HTMLElement) => {
  return element === document.body;
};

export const toastify = (options: Partial<ToastOption>) => {
  if (!document) throw new Error('toastify 는 서버사이드에서 실행할 수 없습니다.');

  const defaultData: _ToastOption = {
    text: 'Toast Message',
    time: 3000,
    position: 'center',
    offset: { x: 0, y: 0 },
    parent: document.body,
    class: '',
    theme: 'default',
    single: false,
  };
  const toastData: _ToastOption = { ...defaultData, ...options };
  toastData.parent = resolveElement(toastData.parent);

  const wrapper = getToastWrapper(toastData.parent, toastData.position);
  if (toastData.single) {
    const existingToasts = wrapper.querySelectorAll(`.${klass.toast}`);
    existingToasts.forEach((toast) => toast.remove());
  }

  const toast = new Toast(toastData);
  wrapper.appendChild(toast.render());

  setTimeout(() => {
    toast.element().classList.add(klass['fade-out']);
    setTimeout(() => {
      toast.element().remove();
      // if (!wrapper.hasChildNodes()) {
      //   wrapper.remove();
      // }
    }, 200);
  }, toastData.time);
};

const getToastWrapper = (parent: HTMLElement, position: ToastPosition) => {
  let $wrapper = parent.querySelector(`.${klass['toast-wrapper']}.${klass[position]}`);
  if (!$wrapper) {
    $wrapper = document.createElement('div');
    $wrapper.className = cx(
      'toast-wrapper',
      klass['toast-wrapper'],
      klass[position],
      isBodyElement(parent) ? klass.fixed : null,
    );
    parent.appendChild($wrapper);
  }
  return $wrapper as HTMLElement;
};
